import { render, staticRenderFns } from "./RoadServiceInfo.vue?vue&type=template&id=16055459"
import script from "./RoadServiceInfo.vue?vue&type=script&lang=ts"
export * from "./RoadServiceInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports